<!-- Desktop HTML -->
<div *ngIf='screenWidth > 1230'>
  <!-- <div class="visible-lg" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-19"></div>
      <div class="flex-62" style="margin-bottom:80px">
        <div class="flex-container row">
          <div class="flex-25"></div>
          <div class="flex-container row flex-align-center">
            <div
              [ngClass]='{"bmw-active-link": isShowBulletins && !(""|brandTypePipe), "mini-active-link": isShowBulletins && (""|brandTypePipe)}'
              class="pointer" style="padding-bottom: 20px" (click)='showBulletins()'>BULLETINS</div>
            <div
              [ngClass]='{"bmw-active-link": isShowVideos && !(""|brandTypePipe), "mini-active-link": isShowVideos && (""|brandTypePipe)}'
              class="pointer" style="padding-bottom: 20px" (click)='showVideos()'>VIDEOS</div>
            <div
              [ngClass]='{"bmw-active-link": isShowDocs && !(""|brandTypePipe), "mini-active-link": isShowDocs && (""|brandTypePipe)}'
              class="pointer" style="padding-bottom: 20px" (click)='showDocs()'>DOCUMENTS</div>
          </div>
          <div class="flex-25"></div>
        </div>
        <div class="bmw-lg-takata-content">
          <div class="flex-container" style="padding:26px 18px 16px 18px">
            <div class="bmw-lg-takata-title flex-60">Takata Recall Info Center</div>
            <div class="flex"></div>
            <div class="flex-30">
              <form class="input-group" name="findDocs" style="width: 100%">
                <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
                  [placeholder]='"Find " + docType' name="techDoc" [(ngModel)]="search4bulletins">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : ''|brandTypePipe, 'bmw-button-style': !(''|brandTypePipe)}"
                    class="btn btn-default" type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div *ngIf='docType === "bulletins"'>
            <div class="alert alert-info" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
            <div
              *ngFor='let doc of takataRecallDocs | searchFilter: "bulletinDisplayId,bulletinDisplayNumber,takataRecallCode,description,seriesAsString": search4bulletins'>
              <div [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}"
                class='pointer flex-container' *ngIf='doc?.bulletinType.toLowerCase() !== "pbs"' style="width:100%"
                (click)='navigateToBulletin(doc)'>
                <div class="flex-5" style="text-align: center">
                  {{doc?.bulletinType}}
                  <ng-template #elseBlock>
                    <ng-container *ngIf='doc?.updatedBulletin; else elseBlock2'>
                      <i class="material-icons">new_releases</i>
                    </ng-container>
                  </ng-template>
                  <ng-template #elseBlock2>
                    <ng-container *ngIf='doc?.newBulletin'>
                      <i class="material-icons">fiber_new</i>
                    </ng-container>
                  </ng-template>
                </div>
                <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
                <div class="flex-4"></div>
                <div class="flex-8" style="color: #bf1a22">{{doc?.takataRecallCode}}</div>
                <div class="flex-2"></div>
                <div class="flex-45">{{doc?.description}}</div>
                <div class="flex-7"></div>
                <div>
                  <div *ngFor='let series of doc?.series' style="float: left; margin-right:18px">
                    {{series?.seriesName}}
                  </div>
                </div>
              </div>
              <a *ngIf='doc?.bulletinType.toLowerCase() === "pbs"' style="width:100%"
                [href]="'mount/parts_bulletin/' + doc?.bulletinFile?.fileName" target="_blank">
                <div [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}"
                  class='pointer flex-container'>
                  <div class="flex-5" style="text-align: center">
                    {{doc?.bulletinType}}
                  </div>
                  <div class="flex-8">{{doc?.bulletinDisplayNumber}}</div>
                  <div class="flex-4"></div>
                  <div class="flex-8" style="color: #bf1a22">{{doc?.takataRecallCode}}</div>
                  <div class="flex-2"></div>
                  <div class="flex-45">{{doc?.description}}</div>
                  <div class="flex-7"></div>
                  <div>
                    <div *ngFor='let series of doc?.series' style="float: left; margin-right:18px">
                      {{series?.seriesName}}
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div *ngIf='docType === "documents"'>
            <div class="alert alert-info" *ngIf='errorMessage?.length > 0'>{{errorMessage}}</div>
            <div *ngFor='let doc of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
              <a [href]='documentTypes.get(doc?.documentType) + "/" + doc?.documentFileName' target="_blank"
                (click)='saveToAnalytics(doc?.documentTitle)'>
                <div class="flex-container"
                  [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}">
                  <div class="flex-30">{{doc?.documentType}}</div>
                  <div class="flex-2"></div>
                  <div class="flex-10" style="color: #bf1a22">{{doc?.documentCampaignCode}}</div>
                  <div class="flex-3"></div>
                  <div class="flex-50">{{doc?.documentTitle}}</div>
                  <div class="flex-5">
                    <i class="material-icons">
                      {{doc?.documentFileType === "pdf" ? "picture_as_pdf" : doc.documentFileType === "zip" ? "file_download" : doc.documentFileType
                      === "xlsx" ? "insert_drive_file" : "" }}
                    </i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div *ngIf='docType === "videos"'>
            <div *ngFor='let video of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
              <div class="flex-container row" style="padding:6px 16px 6px 16px">
                <div class="flex-35">
                  <div class="pointer bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
                    [queryParams]='{channel: "", video: video.id, vimeoID: video.videoFileName,takata: true}'>
                    <img src="assets/images/2015-bmw-i8-1_1035.jpg" title={{video.videoTitle}} width="250px"
                      height="141px" />
                    <div class="bmw-lg-video-home-overlay-text"></div>
                  </div>
                </div>
                <div class="flex">
                  <div style="font-size:16px">{{video.videoNumber}}</div>
                  <div style="font-size:16px">{{video.videoTitle}}</div>
                  <div style="font-size:12px">
                    {{video.releaseDate | date: 'yyyy-MM-dd'}}&nbsp;&nbsp;&nbsp;{{video.views}} views</div>
                </div>
                <div class="dropdown dropdown-pull-right" class="flex-2 flex-column-align-end">
                  <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu" style="top: 25px; position: relative">
                    <li class="row bmw-no-gutter pointer"
                      (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                      <div class="col-lg-2 bmw-no-gutter bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">remove_red_eye</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li class="row bmw-no-gutter pointer" data-toggle="modal" data-target="#shareContent"
                      (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                      <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons dp48" style="font-size:20px">share</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="row bmw-no-gutter">
                      <div class="col-lg-2 bmw-no-gutter  bmw-align-text-right">
                        <i class="material-icons" style="font-size:20px">close</i>
                      </div>
                      <div class="col-lg-9 bmw-no-gutter" style="margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ipad Pro HTML -->
<div *ngIf='screenWidth >= 991 && screenWidth <= 1230'>
  <!-- <div class="visible-md" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex"></div>
      <div class="flex-70" style="margin-bottom:80px">
        <div class="flex-container row">
          <div class="flex-20"></div>
          <div class="flex-container row flex-align-center">
            <div
              [ngClass]='{"bmw-active-link": isShowBulletins && !(""|brandTypePipe), "mini-active-link": isShowBulletins && (""|brandTypePipe)}'
              class="pointer" style="padding-bottom: 20px" (click)='showBulletins()'>BULLETINS</div>
            <div
              [ngClass]='{"bmw-active-link": isShowVideos && !(""|brandTypePipe), "mini-active-link": isShowVideos && (""|brandTypePipe)}'
              class="pointer" style="padding-bottom: 20px" (click)='showVideos()'>VIDEOS</div>
            <div
              [ngClass]='{"bmw-active-link": isShowDocs && !(""|brandTypePipe), "mini-active-link": isShowDocs && (""|brandTypePipe)}'
              class="pointer" style="padding-bottom: 20px" (click)='showDocs()'>DOCUMENTS</div>
          </div>
          <div class="flex-20"></div>
        </div>
        <div class="bmw-lg-takata-content">
          <div class="flex-container" style="padding:26px 18px 16px 18px">
            <div class="bmw-lg-takata-title flex-60" style="font-size:30px">Takata Recall Info Center</div>
            <div class="flex"></div>
            <div class="flex-30">
              <form class="input-group" name="findDocs" style="width: 100%">
                <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
                  [placeholder]='"Find " + docType' name="techDoc" [(ngModel)]="search4bulletins">
                <div class="input-group-btn">
                  <button [ngClass]="{'mini-button-style' : ''|brandTypePipe, 'bmw-button-style': !(''|brandTypePipe)}"
                    class="btn btn-default" type="submit">
                    <i class="glyphicon glyphicon-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div *ngIf='docType === "bulletins"'>
            <div
              *ngFor='let doc of takataRecallDocs | searchFilter: "bulletinDisplayId,bulletinDisplayNumber,takataRecallCode,description,seriesAsString": search4bulletins'>
              <div [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}"
                class='pointer flex-container' *ngIf='doc?.bulletinType.toLowerCase() !== "pbs"' style="width:100%"
                (click)='navigateToBulletin(doc)'>
                <div class="flex-5" style="text-align: center">
                  {{doc?.bulletinType}}
                </div>
                <div class="flex-9">{{doc?.bulletinDisplayNumber}}</div>
                <div class="flex-2"></div>
                <div class="flex-10" style="color: #bf1a22">{{doc?.takataRecallCode}}</div>
                <div class="flex-2"></div>
                <div class="flex-45">{{doc?.description}}</div>
                <div class="flex-7"></div>
                <div>
                  <div *ngFor='let series of doc?.series' style="float: left; margin-right:18px">
                    {{series?.seriesName}}
                  </div>
                </div>
              </div>
              <a *ngIf='doc?.bulletinType.toLowerCase() === "pbs"' style="width:100%"
                [href]="'mount/parts_bulletin/' + doc?.bulletinFile?.fileName" target="_blank">
                <div [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}"
                  class='pointer flex-container'>
                  <div class="flex-5" style="text-align: center">
                    {{doc?.bulletinType}}
                  </div>
                  <div class="flex-9">{{doc?.bulletinDisplayNumber}}</div>
                  <div class="flex-2"></div>
                  <div class="flex-10" style="color: #bf1a22">{{doc?.takataRecallCode}}</div>
                  <div class="flex-2"></div>
                  <div class="flex-45">{{doc?.description}}</div>
                  <div class="flex-7"></div>
                  <div>
                    <div *ngFor='let series of doc?.series' style="float: left; margin-right:18px">
                      {{series?.seriesName}}
                    </div>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div *ngIf='docType === "documents"'>
            <div *ngFor='let doc of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
              <a [href]='doc?.documentFileName' target="_blank">
                <div class="flex-container row"
                  [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}">
                  <div class="flex-30">{{doc?.documentType}}</div>
                  <div class="flex-2"></div>
                  <div class="flex-10" style="color: #bf1a22">{{doc?.documentCampaignCode}}</div>
                  <div class="flex-3"></div>
                  <div class="flex-50">{{doc?.documentTitle}}</div>
                  <div class="flex-5">
                    <i class="material-icons">
                      {{doc?.documentFileType?.toLowerCase() === "pdf" ? "picture_as_pdf" : doc?.documentFileType?.toLowerCase() === "zip" ? "file_download"
                      : doc?.documentFileType?.toLowerCase() === "xlsx" ? "insert_drive_file" : "" }}
                    </i>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div *ngIf='docType === "videos"'>
            <div *ngFor='let video of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
              <div class="flex-container row" style="padding:6px 16px 6px 16px">
                <div class="flex-35">
                  <div class="pointer bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
                    [queryParams]='{channel: "", video: video.id, vimeoID: video.videoFileName,takata: true}'>
                    <img src="assets/images/2015-bmw-i8-1_1035.jpg" title={{video.videoTitle}} width="230px"
                      height="121px" />
                    <div class="bmw-lg-video-home-overlay-text"></div>
                  </div>
                </div>
                <div class="flex">
                  <div style="font-size:16px">{{video.videoNumber}}</div>
                  <div style="font-size:16px">{{video.videoTitle}}</div>
                  <div style="font-size:12px">
                    {{video.releaseDate | date: 'yyyy-MM-dd'}}&nbsp;&nbsp;&nbsp;{{video.views}} views</div>
                </div>
                <div class="dropdown dropdown-pull-right" class="flex-2 flex-column-align-end">
                  <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
                  <ul class="dropdown-menu" style="top: 25px; position: relative">
                    <li style="padding-left:3px" class="pointer flex-container row"
                      (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                      <div>
                        <i class="material-icons dp48" style="float:left;font-size:20px">remove_red_eye</i>
                      </div>
                      <div style="float:left;margin-left: 10px">
                        Add to watchlist
                      </div>
                    </li>
                    <li style="padding-left:3px" class="pointer flex-container row" data-toggle="modal"
                      data-target="#shareContent"
                      (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                      <div>
                        <i class="material-icons dp48" style="float:left;font-size:20px">share</i>
                      </div>
                      <div style="float:left;margin-left: 10px">
                        Share
                      </div>
                    </li>
                    <li class="divider"></li>
                    <li class="flex-container row" style="padding-left:3px">
                      <div>
                        <i class="material-icons" style="float:left;font-size:20px">close</i>
                      </div>
                      <div style="float:left;margin-left: 10px">
                        Cancel
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex"></div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-md-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Ipad HTML -->
<div *ngIf='screenWidth >= 767 && screenWidth <= 991'>
  <!-- <div class="visible-sm" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-20"></div>
      <div class="flex-container row flex-align-center">
        <div
          [ngClass]='{"bmw-active-link": isShowBulletins && !(""|brandTypePipe), "mini-active-link": isShowBulletins && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showBulletins()'>SERVICE BULLETINS</div>
        <div
          [ngClass]='{"bmw-active-link": isShowVideos && !(""|brandTypePipe), "mini-active-link": isShowVideos && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showVideos()'>VIDEOS</div>
        <div
          [ngClass]='{"bmw-active-link": isShowDocs && !(""|brandTypePipe), "mini-active-link": isShowDocs && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showDocs()'>DOCUMENTS</div>
      </div>
      <div class="flex-20"></div>
    </div>
    <div class="bmw-sm-takata-content">
      <div class="flex-container" style="padding:26px 18px 16px 18px">
        <div class="bmw-lg-takata-title flex-60" style="font-size:30px">Takata Recall Info Center</div>
        <div class="flex"></div>
        <div class="flex-30">
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
              [placeholder]='"Find " + docType' name="techDoc" [(ngModel)]="search4bulletins">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : ''|brandTypePipe, 'bmw-button-style': !(''|brandTypePipe)}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngIf='docType === "bulletins"'>
        <div
          *ngFor='let doc of takataRecallDocs | searchFilter: "bulletinDisplayId,bulletinDisplayNumber,takataRecallCode,description,seriesAsString": search4bulletins'>
          <div class="flex-container"
            [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}"
            *ngIf='doc?.bulletinType.toLowerCase() !== "pbs"' style="width:100%" (click)='navigateToBulletin(doc)'>
            <div class="flex-5" style="text-align: center">
              {{doc?.bulletinType}}
            </div>
            <div class="flex-9">{{doc?.bulletinDisplayNumber}}</div>
            <div class="flex-4"></div>
            <div class="flex-8" style="color: #bf1a22">{{doc?.takataRecallCode}}</div>
            <div class="flex-2"></div>
            <div class="flex-45">{{doc?.description}}</div>
            <div class="flex-7"></div>
            <div>
              <div *ngFor='let series of doc?.series' style="float: left; margin-right:18px">
                {{series?.seriesName}}
              </div>
            </div>
          </div>
          <a *ngIf='doc?.bulletinType.toLowerCase() === "pbs"' style="width:100%" [href]="'mount/parts_bulletin/' + doc?.bulletinFile?.fileName"
            target="_blank">
            <div class="flex-container"
              [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}">
              <div class="flex-5" style="text-align: center">{{doc?.bulletinType}}</div>
              <div class="flex-9">{{doc?.bulletinDisplayNumber}}</div>
              <div class="flex-4"></div>
              <div class="flex-8" style="color: #bf1a22">{{doc?.takataRecallCode}}</div>
              <div class="flex-2"></div>
              <div class="flex-45">{{doc?.description}}</div>
              <div class="flex-7"></div>
              <div>
                <div *ngFor='let series of doc?.series' style="float: left; margin-right:18px">
                  {{series?.seriesName}}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div *ngIf='docType === "documents"'>
        <div *ngFor='let doc of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
          <a [href]='doc?.documentFileName' target="_blank">
            <div class="flex-container"
              [ngClass]="{'mini-lg-takata-doc' : ''|brandTypePipe, 'bmw-lg-takata-doc': !(''|brandTypePipe)}">
              <div class="flex-30">{{doc?.documentType}}</div>
              <div class="flex-2"></div>
              <div class="flex-10" style="color: #bf1a22">{{doc?.documentCampaignCode}}</div>
              <div class="flex-3"></div>
              <div class="flex-50">{{doc?.documentTitle}}</div>
              <div class="flex-5">
                <i class="material-icons">
                  {{doc?.documentFileType?.toLowerCase() === "pdf" ? "picture_as_pdf" : doc?.documentFileType?.toLowerCase() === "zip" ? "file_download"
                  : doc?.documentFileType?.toLowerCase() === "xlsx" ? "insert_drive_file" : "" }}
                </i>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div *ngIf='docType === "videos"'>
        <div *ngFor='let video of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
          <div class="flex-container row" style="padding:6px 16px 6px 16px">
            <div class="flex-35">
              <div class="pointer bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
                [queryParams]='{channel: "", video: video.id,vimeoID: video.videoFileName, takata: true}'>
                <img src="assets/images/2015-bmw-i8-1_1035.jpg" title={{video.videoTitle}} width="250px"
                  height="141px" />
                <div class="bmw-lg-video-home-overlay-text"></div>
              </div>
            </div>
            <div class="flex" style="padding-left: 3px">
              <div style="font-size:16px">{{video.videoNumber}}</div>
              <div style="font-size:16px">{{video.videoTitle}}</div>
              <div style="font-size:12px">{{video.releaseDate | date: 'yyyy-MM-dd'}}&nbsp;&nbsp;&nbsp;{{video.views}}
                views</div>
            </div>
            <div class="dropdown dropdown-pull-right" class="flex-2 flex-column-align-end">
              <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu" style="top: 25px; position: relative">
                <li style="padding-left:3px" class="pointer flex-container row"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div>
                    <i class="material-icons dp48" style="float:left;font-size:20px">remove_red_eye</i>
                  </div>
                  <div style="float:left;margin-left: 10px">
                    Add to watchlist
                  </div>
                </li>
                <li style="padding-left:3px" class="pointer flex-container row" data-toggle="modal"
                  data-target="#shareContent"
                  (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                  <div>
                    <i class="material-icons dp48" style="float:left;font-size:20px">share</i>
                  </div>
                  <div style="float:left;margin-left: 10px">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="flex-container row" style="padding-left:3px">
                  <div>
                    <i class="material-icons" style="float:left;font-size:20px">close</i>
                  </div>
                  <div style="float:left;margin-left: 10px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-sm-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- Mobile HTML -->
<div *ngIf='screenWidth > 319 && screenWidth < 767'>
  <!-- <div class="visible-xs" (window:orientationchange)="screenRotate($event)"> -->

  <div (window:orientationchange)="screenRotate($event)">
    <div class="flex-container row">
      <div class="flex-container row flex-align-center">
        <div
          [ngClass]='{"bmw-active-link": isShowBulletins && !(""|brandTypePipe), "mini-active-link": isShowBulletins && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showBulletins()'>BULLETINS</div>
        <div
          [ngClass]='{"bmw-active-link": isShowVideos && !(""|brandTypePipe), "mini-active-link": isShowVideos && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showVideos()'>VIDEOS</div>
        <div
          [ngClass]='{"bmw-active-link": isShowDocs && !(""|brandTypePipe), "mini-active-link": isShowDocs && (""|brandTypePipe)}'
          class="pointer" style="padding-bottom: 20px" (click)='showDocs()'>DOCUMENTS</div>
      </div>
    </div>
    <div class="bmw-xs-takata-content">
      <div style="padding:26px 18px 16px 18px">
        <div class="bmw-lg-takata-title" style="font-size:24px">Takata Recall Info Center</div>
        <div>
          <form class="input-group" name="findDocs" style="width: 100%">
            <input type="text" class="form-control" size=15 style="height:34px;font-size:16px;"
              [placeholder]='"Find " + docType' name="techDoc" [(ngModel)]="search4bulletins">
            <div class="input-group-btn">
              <button [ngClass]="{'mini-button-style' : ''|brandTypePipe, 'bmw-button-style': !(''|brandTypePipe)}"
                class="btn btn-default" type="submit">
                <i class="glyphicon glyphicon-search"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
      <div *ngIf='docType === "bulletins"'>
        <div
          *ngFor='let doc of takataRecallDocs | searchFilter: "bulletinDisplayId,bulletinDisplayNumber,takataRecallCode,description,seriesAsString": search4bulletins'>
          <div [ngClass]="{'mini-xs-takata-doc' : ''|brandTypePipe, 'bmw-xs-takata-doc': !(''|brandTypePipe)}"
            *ngIf='doc?.bulletinType.toLowerCase() !== "pbs"' style="width:100%" (click)='navigateToBulletin(doc)'>
            <div class="flex-container flex-align-center">
              <div class="flex">{{doc?.bulletinDisplayNumber}}</div>
              <div class="flex-10" style="text-align: center">
                {{doc?.bulletinType}}
              </div>
            </div>
            <div class="flex-container row">
              <div class="flex-18">
                <div style="color: #bf1a22; float:left; margin-right:5px">{{doc?.takataRecallCode}}</div>
              </div>
              <div class="flex-2"></div>
              <div class="flex">{{doc?.description}}</div>
            </div>
            <div style="padding-left:10%;height:22px;border-top: 0px solid #e6e7e8;line-height: 2"
              [ngStyle]='{"border-top-width":doc?.series.length > 0 ? "1px" : "0px"}'>
              <div *ngFor="let series of doc?.series" style="float:left;margin-left:5px">
                {{series.seriesName}}
              </div>
            </div>
          </div>
          <a *ngIf='doc?.bulletinType.toLowerCase() === "pbs"' style="width:100%" [href]="'mount/parts_bulletin/' + doc?.bulletinFile?.fileName"
            target="_blank">
            <div [ngClass]="{'mini-xs-takata-doc' : ''|brandTypePipe, 'bmw-xs-takata-doc': !(''|brandTypePipe)}">
              <div class="flex-container flex-align-center">
                <div class="flex">{{doc?.bulletinDisplayNumber}}</div>
                <div class="flex-10" style="text-align: center">
                  {{doc?.bulletinType}}
                </div>
              </div>
              <div class="flex-container row">
                <div class="flex-18">
                  <div style="color: #bf1a22; float:left; margin-right:5px">{{doc?.takataRecallCode}}</div>
                </div>
                <div class="flex-2"></div>
                <div class="flex">{{doc?.description}}</div>
              </div>
              <div style="padding-left:10%;height:22px;border-top: 0px solid #e6e7e8;line-height: 2"
                [ngStyle]='{"border-top-width":doc?.series.length > 0 ? "1px" : "0px"}'>
                <div *ngFor="let series of doc?.series" style="float:left;margin-left:5px">
                  {{series.seriesName}}
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div *ngIf='docType === "documents"'>
        <div *ngFor='let doc of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
          <a [href]='doc?.documentFileName' target="_blank">
            <div [ngClass]="{'mini-xs-takata-doc' : ''|brandTypePipe, 'bmw-xs-takata-doc': !(''|brandTypePipe)}">
              <div class="flex-container">
                <div class="flex-18" style="color: #bf1a22">{{doc?.documentCampaignCode}}</div>
                <div class="flex-75">
                  <div style="float: right">{{doc?.documentType}}</div>
                </div>
                <div class="flex-2"></div>
                <div class="flex-5">
                  <i class="material-icons">
                    {{doc?.documentFileType?.toLowerCase() === "pdf" ? "picture_as_pdf" : doc?.documentFileType?.toLowerCase() === "zip" ? "file_download"
                    : doc?.documentFileType?.toLowerCase() === "xlsx" ? "insert_drive_file" : "" }}
                  </i>
                </div>
              </div>
              <div class="flex-container row">
                <div>{{doc?.documentTitle}}</div>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div *ngIf='docType === "videos"'>
        <div *ngFor='let video of takataRecallDocs | searchFilter: "videoNumber,videoTitle": search4bulletins'>
          <div class="flex-container row" style="padding:6px 0px 6px 0px">
            <div class="flex-40">
              <div class="pointer bmw-lg-video-home-thumbnail" [routerLink]='["/playback"]'
                [queryParams]='{channel: "", video: video.id,vimeoID: video.videoFileName, takata: true}'>
                <img src="assets/images/2015-bmw-i8-1_1035.jpg" title={{video.videoTitle}} width="100%" height="84px" />
                <div class="bmw-lg-video-home-overlay-text"></div>
              </div>
            </div>
            <div class="flex-54" style="padding-left: 3px">
              <div>{{video.videoNumber}}</div>
              <div>{{video.videoTitle.length > 19 ? video.videoTitle.substr(0,20)+"..." : video.videoTitle}}</div>
              <div style="font-size:12px">{{video.releaseDate | date: 'yyyy-MM-dd'}}&nbsp;&nbsp;&nbsp;{{video.views}}
                views</div>
            </div>
            <div class="dropdown dropdown-pull-right" class="flex flex-column-align-end">
              <i class="material-icons pointer" style="opacity: 0.7" data-toggle="dropdown">more_vert</i>
              <ul class="dropdown-menu" style="top: 25px; position: relative">
                <li style="padding-left:3px" class="pointer flex-container row"
                  (click)='addVideoToWatchlist(video?.id, video?.videoDisplayNumber)'>
                  <div>
                    <i class="material-icons dp48" style="float:left;font-size:20px">remove_red_eye</i>
                  </div>
                  <div style="float:left;margin-left: 10px">
                    Add to watchlist
                  </div>
                </li>
                <li class="pointer flex-container row" style="padding-left:3px" data-toggle="modal"
                  data-target="#shareContent"
                  (click)='shareContent(video?.id, "video", video?.channel.channelNumber, video?.videoDisplayNumber)'>
                  <div>
                    <i class="material-icons dp48" style="float:left;font-size:20px">share</i>
                  </div>
                  <div style="float:left;margin-left: 10px">
                    Share
                  </div>
                </li>
                <li class="divider"></li>
                <li class="flex-container row" style="padding-left:3px">
                  <div>
                    <i class="material-icons" style="float:left;font-size:20px">close</i>
                  </div>
                  <div style="float:left;margin-left: 10px">
                    Cancel
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" #modalCloseButton id="shareContent" role="dialog">
      <div class="modal-dialog bmw-xs-share-modal">

        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" style="color:#000000">&times;</button>
            <h4 class="modal-title">Share Content</h4>
          </div>
          <div class="modal-body">
            <app-share-content [shareContent]='shareContentObject'></app-share-content>
          </div>
          <div class="modal-footer" style="border: 0px solid white;">
          </div>
        </div>

      </div>
    </div>
  </div>
</div>